(() => {
  const el = document.getElementById("SpendStretchTracker");
  if (!el) return;

  const htmlEl = document.documentElement;

  const closeBtn = el.querySelector(".spend-stretch-tracker__close");
  const statusEl = el.querySelector("[data-ss-status]");
  const subEl = el.querySelector("[data-ss-sub]");
  const fillEl = el.querySelector("[data-ss-fill]");

  // EDIT TIERS HERE if needed (pence)
  const tiers = [
    { spend: 4900, save: 500 },
    { spend: 7900, save: 800 },
    { spend: 10000, save: 1200 }
  ];

  const isDismissed = () => sessionStorage.getItem("spend_stretch_tracker_dismissed") === "1";

  const setVisible = (visible) => {
    el.hidden = !visible;
    if (visible) htmlEl.classList.add("ss-tracker-visible");
    else htmlEl.classList.remove("ss-tracker-visible");
  };

  const getMoneyFormat = () => {
    // Boost often exposes window.theme.moneyFormat
    if (window.theme && window.theme.moneyFormat) return window.theme.moneyFormat;
    if (window.theme && window.theme.money_format) return window.theme.money_format;
    return "£{{amount}}";
  };

  const formatMoney = (pence) => {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(pence, getMoneyFormat()).replace(".00", "");
      }
    } catch (e) {}
    return "£" + (pence / 100).toFixed(2).replace(/\.00$/, "");
  };

  const computeNextTier = (subtotalPence) => {
    for (const t of tiers) {
      if (subtotalPence < t.spend) {
        const remaining = t.spend - subtotalPence;
        const progress = Math.max(0, Math.min(100, (subtotalPence / t.spend) * 100));
        return { unlocked: false, nextSave: t.save, remaining, progress };
      }
    }
    const top = tiers[tiers.length - 1];
    return { unlocked: true, nextSave: top.save, remaining: 0, progress: 100 };
  };

  const render = ({ subtotalPence, totalPence }) => {
    if (isDismissed()) {
      setVisible(false);
      return;
    }

    const r = computeNextTier(subtotalPence);
    setVisible(true);

    if (!r.unlocked) {
      statusEl.textContent = `You’re ${formatMoney(r.remaining)} away from saving ${formatMoney(r.nextSave)}`;
    } else {
      statusEl.textContent = `Nice — you’ve unlocked ${formatMoney(r.nextSave)} off 🎉`;
    }

    if (totalPence !== subtotalPence) {
      subEl.textContent = `Subtotal: ${formatMoney(subtotalPence)} • Total: ${formatMoney(totalPence)} • Auto-applied at checkout.`;
    } else {
      subEl.textContent = `Subtotal: ${formatMoney(subtotalPence)} • Auto-applied at checkout.`;
    }

    fillEl.style.width = `${r.progress.toFixed(0)}%`;
  };

  const fetchCart = async () => {
    if (isDismissed()) return;

    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;

      const cart = await res.json();
      if (!cart) return;

      const subtotalPence =
        typeof cart.items_subtotal_price === "number"
          ? cart.items_subtotal_price
          : (typeof cart.total_price === "number" ? cart.total_price : 0);

      const totalPence =
        typeof cart.total_price === "number" ? cart.total_price : subtotalPence;

      render({ subtotalPence, totalPence });
    } catch (e) {}
  };

  closeBtn?.addEventListener("click", () => {
    sessionStorage.setItem("spend_stretch_tracker_dismissed", "1");
    setVisible(false);
  });

  // Initial
  if (isDismissed()) setVisible(false);
  else fetchCart();

  // Update after cart fetches
  const origFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    try {
      const url =
        typeof args[0] === "string"
          ? args[0]
          : (args[0] && args[0].url) || "";

      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear") ||
        url.includes("/cart.js")
      ) {
        setTimeout(fetchCart, 250);
      }
    } catch (e) {}
    return response;
  };

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) fetchCart();
  });
})();
